import React from 'react';
import classNames from 'classnames';
import { AdvancedUser } from '@adjust/dashboard-core/api/types';
import { UserGroup } from '@react/Pages/UsersPage/UsersPage/UsersPage.types';

import './UserTile.scss';

export interface AdvancedUserTileProps {
  user: AdvancedUser;
}

export const AdvancedUserTile: React.FC<AdvancedUserTileProps> = ({ user }) => {
  const userUrl = `${configurationURL.advancedPermissions.baseUrl}/admin/users/${user.id}`;

  return (
    <div className="tile user-tile grid-item">
      <h3
        className={classNames('name', 'item-name', {
          empty: !user.full_name,
        })}
        title={user.full_name}
      >
        {user.full_name || t('label.no-name')}
      </h3>

      <h4 className="email" title={user.email}>
        {user.email}
      </h4>

      <span className="role-tag role-advanced">{UserGroup.Advanced}</span>

      <div className="actions-opener flex-box-row">
        <a className="flex-one user-tile__view-link" href={userUrl} rel="noreferrer" target="_blank">
          <span>{t('label.view')}</span>
          <i className="icon-arrow-right" />
        </a>
      </div>
    </div>
  );
};
